import { useEffect } from 'react'
import { useRouter } from 'next/router'

import { useAuth } from '@/contexts/AuthContext'
import { excludedPatterns } from '@/utils/visibility'

// Oculta o widget se a rota contém um dos padrões excluídos
const useZendeskVisibility = () => {
  const router = useRouter()
  const { signed } = useAuth()

  const shouldHideWidget = excludedPatterns.some(pattern =>
    router.asPath.includes(pattern)
  )

  const permanentDisabled = true

  useEffect(() => {
    if (window.zE) {
      if (permanentDisabled || shouldHideWidget || !signed) {
        window.zE('messenger', 'hide')
      } else {
        window.zE('messenger', 'show')
      }
    }
  }, [router.asPath, shouldHideWidget, signed])
}

export default useZendeskVisibility
